import React from 'react';
import { translate } from 'react-i18next';
import moment from 'moment';

// Components
import ExtComp from '../../../../components/external';
import EmptyJobBlock from '../../../../components/EmptyJobs';
import HeaderCell from '../../../../components/TableCells/HeaderCell';
import BodyCell from '../../../../components/TableCells/BodyCell';

// Services
import { getCollSpan } from '../../../../services/jobParsingData';

// Styles
import s from './RescheduleGoalsTable.style';


const RescheduleGoalsTable = (props) => {
  const { t, goals, goToAppointmentDetails } = props;

  return (
    <s.JobAppointments>
      {goals === null ? <ExtComp.RipplePreloader /> : null}
      {Array.isArray(goals) && goals.length === 0 ? <EmptyJobBlock title={t('appointments_table_empty_label')} /> : null}

      {Array.isArray(goals) && goals.length ?
        <table className="jobs-table">
          <thead>
            <tr>
              <th>{t('appointment_time_short')}</th>
              <th>{t('patient')}</th>
              <th>{t('appointment_type_short')}</th>
              <th>{t('appointments_location')}</th>
              <th>{t('job_states')}</th>
              <HeaderCell goal={goals[0]} cellType={'SMS'} translateKey={'sms_status'} />
              <HeaderCell goal={goals[0]} cellType={'Push'} translateKey={'push_status'} />
              <HeaderCell goal={goals[0]} cellType={'Email'} translateKey={'email_status'} />
            </tr>
          </thead>

          <tbody>
            {goals.map((goal) => {
              const appoint = goal.appointment;
              return (appoint ?
                <tr key={goal.id} onClick={() => { goToAppointmentDetails(appoint); }}>
                  <td>
                    {appoint && appoint.dateTime ? moment(appoint.dateTime).format('HH:mm') : t('no_data')}
                    {appoint && appoint.dateTime ?
                      <p className="sub-title">{moment(appoint.dateTime).format('DD.MM.YYYY')}</p>
                      : t('no_data')
                    }
                  </td>
                  <td>
                    <ExtComp.PatientBlockForTable patient={appoint.patient} />
                  </td>
                  <td>{appoint.type || t('no_data')}</td>
                  <td>{appoint.campus && appoint.campus.name || t('no_data')}</td>
                  <td className={goal.status && goal.status.toLowerCase()}>{goal.status || t('no_data')}</td>
                  <BodyCell goal={goal} cellType={'SMS'} />
                  <BodyCell goal={goal} cellType={'Push'} />
                  <BodyCell goal={goal} cellType={'Email'} />
                </tr> :
                <tr key={Math.random()} className="event-in-process">
                  <td colSpan={getCollSpan(goals)}>{t('event_in_process')}</td>
                </tr>
              );
            })
            }
          </tbody>
        </table>
        : null
      }
    </s.JobAppointments>
  );
};

export default translate()(RescheduleGoalsTable);
